<div class="text-center m-y-2 w-100 item-wrapper d-flex justify-content-center align-item-center">
  <span translate="MAPPING.CHOOSE_THE_TYPE"></span>
</div>
<div class="item-wrapper d-flex justify-content-center align-item-center">
